import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  removeFromCart,
  clearCart,
  updateCartItem,
} from "../../store/cartItemsSlice";
import { useNavigate } from "react-router-dom";
import icons from "../../icons.config";
import { FOUNDER_IMAGE_URL } from "../../api-urls";
import { fetchCartItems } from "../../Providers/cartProvider";

const CartSlider = ({ toggleCartSlider }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [subTotal, setSubTotal] = useState(0);

  // const cartItems = useSelector((state) => state.cartItems?.cartItems || []);
  console.log("my cart itmesssssssssss-----------", cartItems);

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    const data = await fetchCartItems();
    setCartItems(data.data);
    
    const totalAmount = data.data.reduce((sum, item) => {
      // Check if discount_price exists (skip the first item which has no price)
      if (item.discount_price) {
          // Convert discount_price to number and multiply by quantity
          return sum + (Number(item.discount_price) * item.quantity);
      }
      return sum;
  }, 0);
    // for(let i = 0; i < data.data.length; i){
    //  const singleData = data.data[i];
    //  console.log(singleData);
    //  const discountedPrice = parseInt(singleData.discount_price);
    //  const qty = singleData.quantity;

    //  const price = discountedPrice * qty;
    //  total+=price;
     

    // }

    setSubTotal(totalAmount);
    console.log(totalAmount);

    console.log("cart data from api-----", data);
  };

  // Handle removing a single cart item
  const handleRemove = (itemId) => {
    dispatch(removeFromCart({ id: itemId }));
  };

  // Handle clearing all cart items
  const handleClearAll = () => {
    dispatch(clearCart());
  };

  // Navigate to shop page
  const goToShop = () => {
    navigate("/shop");
  };

  // Handle quantity increment/decrement
  const handleQuantityChange = (itemId, change) => {
    console.log("Updating Quantity for Item ID:", itemId, "Change:", change);
    dispatch(updateCartItem({ id: itemId, change }));
  };

  // Calculate subtotal
  // const subtotal = cartItems.reduce(
  //   (total, item) => total + item.discountedPrice * item.quantity,
  //   0
  // );

  // const handleCheckout = () => {
  //   const cartItemsWithGST = cartItems.map(item => {
  //     const gst = item.discountedPrice * 0.18;
  //     return { ...item, gst };
  //   });

  //   const totalPrice = cartItemsWithGST.reduce((total, item) => total + item.discountedPrice * item.quantity + item.gst, 0);

  //   navigate("/checkout", {
  //     state: {
  //       cartItems: cartItemsWithGST,
  //       totalPrice,
  //     },
  //   });
  // };

  const handleCheckout = () => {
    const gstPercentage = 18; // Assuming 18% GST
    const subtotal = cartItems.reduce(
      (acc, item) => acc + item.discountedPrice * item.quantity,
      0
    );
    const gstAmount = (subtotal * gstPercentage) / 100;
    const totalPrice = subtotal + gstAmount;

    // const gst = clickedItem.price * 0.18; // Example GST calculation
    // const totalPrice = clickedItem.discountedPrice + gst;

    navigate("/checkout", {
      state: {
        cart: cartItems, // Pass the whole cart array
        gst: gstAmount,
        totalPrice: totalPrice,
      },
    });
  };

  const [quantity, setQuantity] = useState(1);

  return (
    <div className="fixed top-0 bg-tertiary right-0 w-[90%] lg:w-1/3 h-full bg-white shadow-lg z-50 transition-transform duration-300 ease-in-out flex flex-col">
      {/* Close Button */}
      <div className="p-4 flex justify-end items-end">
        <FontAwesomeIcon
          icon={faTimes}
          className="cursor-pointer text-primary1 text-xl"
          onClick={toggleCartSlider}
        />
      </div>

      <div className="px-7 flex-grow overflow-y-auto">
        {cartItems.length > 0 ? (
          <>
            {/* Cart Heading and Clear All Button */}
            <div className="flex items-center mb-4">
              <h2 className="text-lg font-outfit text-hcolor">
                Cart ({cartItems.length})
              </h2>
              <button
                className="text-sm text-red-500 font-medium underline ml-auto"
                onClick={handleClearAll}
              >
                Clear All
              </button>
            </div>

            {/* Cart Items List */}
            {cartItems.map((item) => {
              // console.log("cart item----", item);
              const price = item?.price || 0;
              const discountedPrice =
                item?.discount_price || 0;
              const image =
                item?.variant_main_image || "";
                const size =item?.size || "";
                const color = item?.color || "";
                const productName = item?.product_name || "";
                const qty = item?.quantity || 1;
                const variantId = item?.variant_id ||"0";

              return (
                <div key={item.id} className="flex gap-4 mb-6 items-start ">
                  <div className="relative w-[30%] lg:w-[20%]">
                    <img
                      src={FOUNDER_IMAGE_URL + image}
                      alt={image}
                      className="w-full object-cover"
                    />
                    <button
                      className="absolute -top-2 -right-2"
                      onClick={() => handleRemove(variantId)}
                    >
                      <img src={icons.removeLikedItem} alt="remove item" />
                    </button>
                  </div>

                  {/* Details */}
                  <div className="flex flex-col flex-1 gap-2">
                    <p className="font-outfit font-bold text-lg">
                      {productName}
                    </p>
                    <p className="text-sm text-gray-500">
                      Size: {size}
                    </p>
                    {/* Quantity Controls */}
                    <div className="flex items-center gap-2">
                      {/* Decrease Quantity */}
                      <button
                        onClick={() => handleQuantityChange(item.id, -1)}
                        className="text-sm text-hcolor px-2 py-1 border rounded hover:bg-hcolor hover:text-white"
                        disabled={item.quantity === 1}
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>

                      {/* Display Quantity */}
                      <span className="text-sm">{qty}</span>

                      {/* Increase Quantity */}
                      <button
                        onClick={() => handleQuantityChange(item.id, 1)}
                        className="text-sm text-hcolor px-2 py-1 border rounded hover:bg-hcolor hover:text-white"
                      >
                        <FontAwesomeIcon icon={faPlus} />
                      </button>
                    </div>
                  </div>
                  {/* Pricing and Stock */}
                  <div className="text-right">
                    <p className="text-lg font-bold text-primary">
                      Rs.{discountedPrice}
                    </p>
                    <p className="text-sm text-gray-500 line-through">
                      Rs.{price}
                    </p>
                    <p
                      className={`text-sm ${
                        item.inStock ? "text-green-500" : "text-red-500"
                      }`}
                    >
                      {item.inStock ? "In Stock" : "Out of Stock"}
                    </p>
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <div className="flex flex-col items-center mt-40 space-y-4">
            <img
              src={icons.emptyCart} // Replace with your image URL
              alt="Rotating Animation"
              className="w-32 transform transition-transform duration-500 hover:rotate-180" // Rotate on hover
            />
            <p className="text-center text-hcolor">Your cart is empty!</p>
            <button
              onClick={goToShop}
              className="border-2 py-2 px-5 text-hcolor font-outfit font-medium hover:bg-hcolor hover:text-primary2 bg-white transition-all duration-500"
            >
              Shop Now
            </button>
          </div>
        )}
      </div>

      {/* Subtotal Section */}
      {cartItems.length > 0 && (
        <div className="px-7 py-4 border-t bg-primary2">
          <div className="flex justify-between text-lg font-medium">
            <span>Subtotal</span>
            <span>Rs.{subTotal}</span>
          </div>
          <p className="text-sm text-gray-500">
            Tax Included, shipping calculated at checkout.
          </p>
          <button
            className="mt-10 w-full py-3 bg-hcolor text-tertiary font-medium hover:bg-primary-dark transition-all duration-300"
            onClick={handleCheckout}
          >
            Checkout
          </button>
        </div>
      )}
    </div>
  );
};

export default CartSlider;